module.exports = __webpack_public_path__ + "img/chat-screen.2f144a04.png";